// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__U+LNP","loader":"styles_loader__8rU1t","spin":"styles_spin__CmySI"};